import * as angular from "angular";
import {IComponentController, INgModelController, IScope} from "angular";
import './edit.user.dialog.component.scss';
import {UserDto} from "../../model/User";
import {BrandService} from "../../../brand_service/service/BrandService";
import {
    BrandServiceName,
    ToastNotificationServiceName,
    UserServiceName,
    UserValidationServiceName
} from "../../../utils/names/serviceNames";
import {UserService} from "../../../users_service/service/user.service";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {AccessLevelToggle, APPLICATION_ACCESS_LEVEL_TOGGLES} from "../../model/AccessLevelToggle";
import {UserValidationService} from "../../../users_service/service/user-validation.service";
import {Principle} from "../../../brand_service/model/Principle";
import {AccessLevelConfig} from "../../model/AccessLevelConfig";

export interface NewUserDialogScope extends IScope {
    accessLevelChange: ($event) => void;
    accessLevelToggles: AccessLevelToggle[];
    accessLevelConfig: AccessLevelConfig;
    setSelectedBranchesId: (ids: number[]) => void;
    isNewUser: boolean;
    switchInputType: () => void;
    submitUser: () => void;
    disableSubmitUser: (form: INgModelController) => boolean;
    eyeIconColor: string;
    user: UserDto;
    loggedInUser: Principle;
    account: UserDto;
    passwordInputType: string;
    controllButtonsDisabled: boolean;
    getSuperAdminFeatureTheme: () => any;
    showLoader: boolean;
}

export class EditUserDialogComponent implements IComponentController {


    static instance = ($event: MouseEvent,
                       user: UserDto,
                       loggedInUser: Principle,
                       parent = document.body): angular.material.IDialogOptions => ({
        template: require('./edit.user.dialog.component.html'),
        controller: [
            '$scope',
            '$mdDialog',
            'user',
            'loggedInUser',
            BrandServiceName,
            UserServiceName,
            ToastNotificationServiceName,
            '$mdColors',
            UserValidationServiceName,
            EditUserDialogComponent
        ],
        locals: {
            user: user,
            loggedInUser: loggedInUser
        },
        multiple: true,
        parent: angular.element(parent),
        targetEvent: $event,
        clickOutsideToClose: true,
        fullscreen: true,
    });

    private accessLevelToggles: AccessLevelToggle[] = APPLICATION_ACCESS_LEVEL_TOGGLES();

    constructor(private $scope: NewUserDialogScope,
                private $mdDialog: angular.material.IDialogService,
                user: UserDto,
                private loggedInUser: Principle,
                private brandService: BrandService,
                private userService: UserService,
                private toastNotificationService: ToastNotificationService,
                private $mdColors: angular.material.IColorService,
                private userValidationService: UserValidationService) {
        $scope.accessLevelChange = this.accessLevelChange;
        $scope.accessLevelToggles = this.accessLevelToggles;
        $scope.passwordInputType = 'text';
        $scope.user = user;
        $scope.loggedInUser = loggedInUser;
        $scope.switchInputType = this.switchInputType;
        $scope.isNewUser = user.id == null;
        $scope.submitUser = this.submitUser;
        $scope.disableSubmitUser = this.disableSubmitUser;
        $scope.controllButtonsDisabled = false;
        $scope.setSelectedBranchesId = this.setSelectedBranchesId;
        $scope.getSuperAdminFeatureTheme = this.getSuperAdminFeatureTheme;
        $scope.accessLevelConfig = this.buildAccessLevelConfig();
        this.switchInputType();
    }

    switchInputType = () => {
        var color = this.$mdColors.getThemeColor('default-primary-500');
        let $scope = this.$scope;
        if ($scope.passwordInputType === 'text') {
            $scope.eyeIconColor = 'white';
            $scope.passwordInputType = 'password';
        } else {
            $scope.eyeIconColor = color;
            $scope.passwordInputType = 'text';
        }
    };


    private accessLevelChange = (acessLevel) => {
        this.$scope.user.accessLevel = acessLevel;
    };

    private updateLoadingStatus = (status: boolean) => {
        let $scope = this.$scope;
        $scope.controllButtonsDisabled = status;
        $scope.showLoader = status;
    };

    disableSubmitUser = (form: INgModelController): boolean => {
        return this.$scope.controllButtonsDisabled || form.$invalid;
    };

    submitUser = () => {
        if (this.userValidationService.validateUser(this.$scope.user)) {
            this.$scope.controllButtonsDisabled = true;
            if (this.$scope.user.id) {
                this.updateUser();
            } else {
                this.saveUser();
            }
        }
    };

    private saveUser = () => {
        this.userService.saveUser(this.$scope.user)
            .then(resp => {
                if (resp.status == 200) {
                    this.handlePersistenceSuccess(resp);
                } else {
                    this.handlePersistenceError();
                }
            });
    };

    private updateUser = () => {
        this.userService.updateUser(this.$scope.user)
            .then(this.handlePersistenceSuccess, this.handlePersistenceError);
    };

    private handlePersistenceError = () => {
        this.$scope.controllButtonsDisabled = false;
        this.toastNotificationService.generateErrorMessage("Failed to create the user!");
    };

    private handlePersistenceSuccess = resp => {
        this.$scope.controllButtonsDisabled = false;
        this.toastNotificationService.generateSuccessMessage(`User was successfully ${this.$scope.user.id ? 'updated' : 'created'}!`);
        this.$mdDialog.hide(resp.data);
    };


    setSelectedBranchesId = (id: any) => {
        this.$scope.user.branch = id;
    };

    private buildAccessLevelConfig(): AccessLevelConfig {
        return {
            disabled: !(this.loggedInUser.isSuperAdmin || this.loggedInUser.userType === 'Admin'),
            isNewUser: this.$scope.isNewUser
        }
    }

    getSuperAdminFeatureTheme = () => {
        if (!(this.loggedInUser.isSuperAdmin || this.loggedInUser.userType === 'Admin')) {
            return 'super-admin-only-feature';
        }
    }
}